// extracted by mini-css-extract-plugin
export var actions = "_ty-4";
export var item = "_ty-1";
export var price = "_ty-3";
export var quantity = "_ty-2";
export var table = "_ty-0";